import "@/config"

export default function register() {
    // empty
}